import { InstructorsScreen } from "./instructors.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { InstructorEditRoutes } from "../instructor-edit";

export const InstructorsRoutes: RouteDefinition[] = [
	{
		path: Paths.instructors.path,
		element: <InstructorsScreen />,
		requiredPermissions: ["UserInAccountPermission_Instructors_ReadInstructors"],
	},
	...InstructorEditRoutes,
];
